import nodeApi from '@/api/node'

const node = {
  namespaced: true,
  actions: {
    async checkRunningNodes() {
      const { code, statistics } = await nodeApi.getNodeStats(undefined, {
        noErrMsg: true
      })
      if (code === 0 && statistics && statistics.stats) {
        const { stats } = statistics
        return !!Object.keys(stats)
          .filter(k => !['3', '4', '6'].includes(k))
          .reduce((prev, curr) => {
            return prev + (stats[curr] || 0)
          }, 0)
      }
    }
  }
}

export default node
